module.exports = __webpack_public_path__ + "static/media/logo-mark.aecd0d3b.svg";